import axios from "axios";
import { getToken } from "@/utils";
import router from "../router";

const request = axios.create({
  baseURL: "https://ghej.zhengguannews.cn/api/data/",
  timeout: 5000, // request timeout
});

// 请求拦截器
request.interceptors.request.use(
  config => {
    let token = getToken();
    if (token) {
      config.headers["X-Token"] = token;
      config.headers["token"] = token;
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    // if (response.status == 200) {
    //   if (response.data.code == 401) {
    //     localStorage.removeItem("token");
    //     router.push("/login");
    //     return;
    //   }
    //   return response.data;
    // }
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // 未授权，跳转到登录页
      localStorage.removeItem("token");
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

export default request;
